import React from "react";
import styled from "styled-components";
import withTheme from "../../hoc/withTheme";
import { DARK_THEME, LIGHT_THEME } from "../../state/actions/theme.action";
import IosSunny from "react-ionicons/lib/IosSunny";
import IosMoon from "react-ionicons/lib/IosMoon";

const ThemeButton = props => {
  const { theme, setDarkTheme, setLightTheme } = props;

  const handleToggle = () => {
    switch (theme.name) {
      case DARK_THEME:
        setLightTheme();
        break;
      case LIGHT_THEME:
      default:
        setDarkTheme();
        break;
    }
  };

  return (
    <Container>
      {theme.name === DARK_THEME ? (
        <IosSunny
          onClick={handleToggle}
          fontSize="40px"
          color={theme.colors.background.text}
        />
      ) : (
        <IosMoon
          onClick={handleToggle}
          fontSize="40px"
          color={theme.colors.background.text}
        />
      )}
    </Container>
  );
};

const Container = styled.div`
  cursor: pointer;
  justify-content: center;
  align-items: center;
  display: flex;
`;

export default withTheme(ThemeButton);
